


































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Slide } from '../@types/Slide'
import { AsyncComponentFactory, AsyncComponentPromise } from 'vue/types/options'
import { startCase } from 'lodash'
import LoadingTemplate from './LoadingTemplate.vue'
import ErrorTemplate from './ErrorTemplate.vue'

@Component({
  name: 'tracker',
  components: { Tracker }
})
export default class Tracker extends Vue {
  @Prop() public slides!: Slide[]
  @Prop({ default: '' }) public path: string
  @Prop() public parentIndex: number
  @Prop({ default: false }) public opened: boolean
  @Prop({ default: false }) public numbered: boolean

  /**
   * Show sub slides.
   */
  public showSubSlides: number = null

  /**
   * Toggle subslides.
   */
  public toggleSubSlides(index: number) {
    if (!this.opened) {
      if (this.showSubSlides === index) {
        this.showSubSlides = null
      } else {
        this.showSubSlides = index
      }
    }
  }

  /**
   * Should show subslides.
   */
  public shouldShow(index: number) {
    return this.opened || this.showSubSlides === index
  }

  /**
   * Get path for index.
   */
  public getPathForIndex(index: number) {
    const project = this.path ? '' : `/${this.$route.params.project}`
    return `${project}${this.path}/${index + 1}`
  }

  /**
   * Open parent at index.
   */
  public openParentAtIndex(index: number) {
    if (this.$parent instanceof Tracker) {
      ;(this.$parent as Tracker).showSubSlides = index
      this.$parent.openParentAtIndex(this.$parent.parentIndex)
    }
  }

  /**
   * Close children.
   */
  public closeChildren() {
    this.showSubSlides = null
    this.$children.forEach(child => {
      if (child instanceof Tracker) {
        ;(child as Tracker).showSubSlides = null
        child.closeChildren()
      }
    })
  }

  /**
   * Check if it is the current path.
   */
  public isCurrentPath(index: number) {
    if (this.$route.path === this.getPathForIndex(index)) {
      this.openParentAtIndex(this.parentIndex)
      return true
    }
  }

  /**
   * Get text from HTML.
   */
  public getText(index: number, html: string) {
    const tmp = document.createElement('div')

    tmp.innerHTML = html
      .replace(/<br ?\/>/g, ' ')
      .replace(/<p>(.*?)<\/p>/, '$1 ')

    return (
      (this.numbered
        ? `<strong>${this.getPathForIndex(index)
            .replace(/^\//g, '')
            .replace(/\//g, '.') + '. '}</strong>`
        : '') + (tmp.textContent || tmp.innerText || '').replace(/:$/, '')
    )
  }
}
